/** * 头部菜单 */
<template>
  <div class="tou">
    <el-menu
      class="el-menu-demo"
      mode="horizontal"
      background-color="#334157"
      text-color="#fff"
      active-text-color="#fff"
    >
      <el-button class="buttonimg">
        <img
          class="showimg"
          :src="collapsed ? imgsq : imgshow"
          @click="toggle(collapsed)"
        />
      </el-button>
      <el-submenu index="2" class="submenu">
        <template slot="title">{{ user.name || "" }}</template>
        <!--      <el-menu-item index="2-1">设置</el-menu-item>-->
        <!--      <el-menu-item @click="content()" index="2-2">个人中心</el-menu-item>-->
        <el-menu-item @click="exit()" index="2-3">退出</el-menu-item>
      </el-submenu>
    </el-menu>
    <div class="tag cursor_pointer">
      <el-tag
        v-for="(tag, index) in $store.state.editableTags"
        size="medium"
        :key="tag.path"
        @click="goTo(tag.path)"
        @close="close(index)"
        :closable="index !== 0"
      >
        {{ tag.title }}
      </el-tag>
    </div>
  </div>
</template>
<script>
import { logout } from "@/api/login/index";
export default {
  name: "navcon",
  data() {
    return {
      collapsed: true,
      imgshow: require("../assets/img/show.png"),
      imgsq: require("../assets/img/sq.png"),
      user: {},
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(val, oldVal) {
        this.$store.commit("ADD_TABS", val);
      },
    },
    userInfo: {
      handler(val, oldVal) {
        if (val) {
          this.user = val;
        }
      },
      immediate: true, // 立即执行
    },
  },
  computed: {
    userInfo() {
      return (
        this.$store.state.userInfo ||
        JSON.parse(localStorage.getItem("userInfo"))
      );
    },
  },
  // 创建完毕状态(里面是操作)
  mounted() {
    // this.user = JSON.parse(localStorage.getItem("userInfo")) || {};
  },
  methods: {
    // tag标签跳转
    goTo(path) {
      this.$router.replace({
        path: path == "/" || path == undefined ? "/Hndex" : path,
      });
    },
    close(index) {
      this.$store.dispatch("resetTags", {
        index: index,
        $route: this.$route,
        $router: this.$router,
      });
    },
    // 退出登录
    exit() {
      this.$confirm("退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          logout({ userId: this.user.id }, (res) => {
            this.$store.commit("logout", "false");
            localStorage.removeItem("userInfo");
            // this.$router.push({ path: "/login" });
            this.$message({
              type: "success",
              message: "已退出登录!",
            });
            window.open(`https://www.appbyt.com/pcPage.html`, "_self");
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype;
      this.$root.Bus.$emit("toggle", this.collapsed);
    },
  },
};
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}

.submenu {
  float: right;
}

.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}

.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}

.showimg:active {
  border: none;
}

.tou {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 5px;
  box-sizing: border-box;
}
.tag {
  padding-left: 10px;
}
.tag > span {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/navcon.vue